import { Injectable } from "@angular/core";

import { datesToDb, dbToDates, dbToInts, intsToDb } from "@dffedb/util";
import {
    DbMaalerAflaesning,
    DbMaalerAflaesningMedNoter,
    MaalerAflaesning,
    MaalerAflaesningDbMapper,
    MaalerAflaesningMedNoter
} from "@e-forsyning/common/maaler";
import { NoteDbMapperService } from "@e-forsyning/common/note";

import { BatteriskiftDataDto } from "./model/batteriskift-data.dto";
import { BatteriskiftData } from "./model/batteriskift-data.model";
import { BatteriskiftDto } from "./model/batteriskift.dto";
import { Batteriskift } from "./model/batteriskift.model";

@Injectable({ providedIn: "root" })
export class BatteriskiftMapper {
    constructor(private readonly maalerAflaesningDbMapper: MaalerAflaesningDbMapper, private readonly noteDbMapper: NoteDbMapperService) {}

    public dtoToBatteriskiftData(data: BatteriskiftDataDto, bilagUrlTemplate: string): BatteriskiftData {
        const result: any = {
            ...data,
            batteriskift: this.dtoToBatteriskift(data.batteriskift, bilagUrlTemplate)
        };
        return result as BatteriskiftData;
    }

    public dtoToBatteriskift(data: BatteriskiftDto, bilagUrlTemplate: string): Batteriskift {
        const result: Batteriskift = {
            dato: dbToDates(data.dato),
            maalerFoerBatteriskift: this.dtoToMaalerAflaesningMedNoter(data.gammelMaaler, bilagUrlTemplate),
            huskelisteId: dbToInts(data.huskelisteId),
            maalerEfterBatteriskift: this.dtoToMaalerAflaesning(data.nyMaaler, bilagUrlTemplate)
        };
        return result;
    }

    public batteriskiftDataToDto(data: BatteriskiftData): BatteriskiftDataDto {
        const result: BatteriskiftDataDto = {
            ...data,
            batteriskift: this.batteriskiftToDto(data.batteriskift)
        };
        return result;
    }

    public batteriskiftToDto(data: Batteriskift): BatteriskiftDto {
        const result: BatteriskiftDto = {
            dato: datesToDb(data.dato),
            gammelMaaler: this.maalerAflaesningMedNoterToDto(data.maalerFoerBatteriskift),
            huskelisteId: intsToDb(data.huskelisteId),
            nyMaaler: this.maalerAflaesningToDto(data.maalerEfterBatteriskift)
        };
        return result;
    }

    private dtoToMaalerAflaesning(data: DbMaalerAflaesning, bilagUrlTemplate: string): MaalerAflaesning {
        const maalerAflaesning = this.maalerAflaesningDbMapper.dbToMaalerAflaesning(data);
        const result = {
            ...maalerAflaesning
        };
        return result;
    }

    private dtoToMaalerAflaesningMedNoter(data: DbMaalerAflaesningMedNoter, bilagUrlTemplate: string): MaalerAflaesningMedNoter {
        const maalerAflaesning = this.maalerAflaesningDbMapper.dbToMaalerAflaesning(data);
        const noter = this.noteDbMapper.dbToNoter(data.noter, bilagUrlTemplate);
        const result = {
            ...maalerAflaesning,
            noter
        };
        return result;
    }

    private maalerAflaesningToDto(data: MaalerAflaesning): DbMaalerAflaesning {
        const aflaesning = this.maalerAflaesningDbMapper.maalerAflaesningToDb(data);
        const result: DbMaalerAflaesning = {
            ...aflaesning
        };
        return result;
    }

    private maalerAflaesningMedNoterToDto(data: MaalerAflaesningMedNoter): DbMaalerAflaesningMedNoter {
        const aflaesning = this.maalerAflaesningDbMapper.maalerAflaesningToDb(data);
        const noter = this.noteDbMapper.noterToDb(data.noter);
        const result: DbMaalerAflaesningMedNoter = {
            ...aflaesning,
            noter
        };
        return result;
    }
}
